import {HeaderFooterToolboxOptions, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import {PortalAddHeaderFooter} from "./PortalAddHeaderFooter";

export enum HeaderFooterFunction {
	ADD = "add",
	REMOVE = "remove"
}

export class PortalHeaderFooterToolboxOptions extends HeaderFooterToolboxOptions implements Parameter {
	public mode?: HeaderFooterFunction;

	constructor(data: any) {
		super(data);

		this.mode = FunctionHelper.exists(data?.mode) ? data.mode : HeaderFooterFunction.ADD;
		this.add = PortalAddHeaderFooter.fromJson(data?.add);
	}

	public static getModeDefault(): HeaderFooterFunction {
		return HeaderFooterFunction.ADD;
	}

	public static fromJson(data: any): PortalHeaderFooterToolboxOptions {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalHeaderFooterToolboxOptions(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'mode': this.mode
		};
	}

	public clone(): PortalHeaderFooterToolboxOptions {
		return PortalHeaderFooterToolboxOptions.fromJson(this.toJson());
	}
}